import React, { ReactElement } from "react";
import GiftVoucherList from "../components/GiftVoucher";
import Layout from "../components/layout";

const GiftVoucherPage = (): ReactElement => {
  return (
    <Layout>
      <GiftVoucherList />
    </Layout>
  );
};

export default GiftVoucherPage;
